import { UserProps } from '@img-arena/consoles-api-dde'
import { User } from '@img-arena/consoles-api-streaming'
import { OpenDialogButton } from '@/components/ConsoleDialog/handlers'
import { PlatformDependent } from '@/components/PlatformDependent'
import { FormDialogProps } from '@/types/forms'

import { DDE_FormikValues, DDEUserForm } from './UserForm.dde'
import { DGEUserForm } from './UserForm.dge'

// TODO: refactor to not use users service but ddeApi and streamingApi instead from console packages
const DDEFormButton = ({
  defaultValues,
  ...props
}: FormDialogProps<UserProps<never>, undefined, keyof DDE_FormikValues>) => (
  <PlatformDependent dde>
    <OpenDialogButton label="Add User">
      <DDEUserForm {...props} defaultValues={defaultValues} />
    </OpenDialogButton>
  </PlatformDependent>
)

const DGEFormButton = ({ defaultValues, ...props }: FormDialogProps<User>) => (
  <PlatformDependent streaming>
    <OpenDialogButton label="Add User">
      <DGEUserForm {...props} defaultValues={defaultValues} />
    </OpenDialogButton>
  </PlatformDependent>
)

export const UserFormButton = {
  DDE: DDEFormButton,
  DGE: DGEFormButton
}
